__turbopack_context__.v({
  "group": "CapacityConflictItemsList-module-scss-module__Ph227W__group",
  "itemsList": "CapacityConflictItemsList-module-scss-module__Ph227W__itemsList",
});
